module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "abs",
    staticStyle: {
      "top": "0px",
      "right": "0px"
    }
  }, [_c('div', {
    staticClass: "contentMenu"
  }, _vm._l((_vm.getRelatedTicketsStrip), function(ticket) {
    return _c('div', {
      staticClass: "content-ticket"
    }, [_c('img', {
      staticClass: "img-ticket",
      attrs: {
        "src": _vm.getUrlImage(ticket),
        "width": "70%"
      },
      on: {
        "mousedown": function($event) {
          _vm.cloneTicketStrip($event.target, ticket);
        }
      }
    })])
  }))])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-f1116262","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/plano/menu/TicketStrip.vue
// module id = 3396
// module chunks = 0